import { Component } from 'react'
import PropTypes from 'prop-types'

class DiscountCodeInput extends Component {
  render() {
    const {
      name,
      value,
      placeholder,
      isValid,
      error,
      onChange,
      showCodeText,
      showCodeInput,
      inputVisible,
    } = this.props
    return (
      <div className="ctp-discount-code-input form">
        {!inputVisible && (
          <a href="#" className="ctp-discount-code-input__activate" onClick={showCodeInput}>
            {showCodeText}
          </a>
        )}
        {inputVisible && (
          <div className="field">
            <div className="control has-icons-right">
              <input
                className="input"
                type="text"
                name={name}
                value={value || ''}
                onChange={onChange}
                placeholder={placeholder}
              />
              {value && isValid && (
                <span className="icon is-medium is-right">
                  <i className="fa fa-check" />
                </span>
              )}
            </div>
            {error && <p>{error}</p>}
          </div>
        )}
      </div>
    )
  }
}

DiscountCodeInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  isValid: PropTypes.bool,
  error: PropTypes.string,
  onChange: PropTypes.func,
  showCodeText: PropTypes.string,
  showCodeInput: PropTypes.func,
  inputVisible: PropTypes.bool,
}

export default DiscountCodeInput
